/** フレーム未取得時（日付/試合 未選択）のフォールバック値。上限20の仕様は維持する。 */
export const DEFAULT_MIN_PERSON_NUM = 1;
export const DEFAULT_MAX_PERSON_NUM = 20;

/**
 * 人数選択肢の範囲算出に必要なフレームの最小形。
 * バリデーションと同一ソース (`reservationPlan.min/maxPersonNum`) を使い整合を担保する。
 */
export type FrameForPersonNumRange = {
  reservationPlan: {
    minPersonNum: number;
    maxPersonNum: number;
  };
};

/**
 * 取得済みフレーム群から人数選択肢の範囲を算出する。
 *
 * - 上限 (ceiling) = 全フレームの `maxPersonNum` の最大値
 *   → 少なくとも1つのプランで予約可能な人数しか選べないようにする
 * - 下限 (floor)   = 全フレームの `minPersonNum` の最小値
 *
 * フレーム未取得時は 1〜20 をフォールバックする。
 */
export const getPersonNumRange = (
  frames: ReadonlyArray<FrameForPersonNumRange>
): { min: number; max: number } => {
  if (frames.length === 0) {
    return { min: DEFAULT_MIN_PERSON_NUM, max: DEFAULT_MAX_PERSON_NUM };
  }

  return {
    min: Math.min(...frames.map((f) => f.reservationPlan.minPersonNum)),
    max: Math.max(...frames.map((f) => f.reservationPlan.maxPersonNum)),
  };
};

/**
 * 取得済みフレーム群から人数選択肢 (下限〜上限の連番) を生成する。
 * 例: 下限1・上限3 → [1, 2, 3]
 */
export const getPersonNumOptions = (
  frames: ReadonlyArray<FrameForPersonNumRange>
): number[] => {
  const { min, max } = getPersonNumRange(frames);
  return Array.from({ length: max - min + 1 }, (_, i) => min + i);
};
